export const formatNumber = (value) => {
    if (value === 'N/A') return 'N/A';
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatNumberOneDecimal = (value) => {
    if (value === 'N/A') return 'N/A';
    return value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatNumberTwoDecimal = (value) => {
    if (value === 'N/A') return 'N/A';
    return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatPercent = (value) => `${value}%`;

export const formatDollar = (value) => `$${value}`;

export const formatDollarBillions = (value) => `$${value}B`;
